export const ENV = {
	PROD_AWS: 'AWS_FUT',
	STAGING_AWS: 'AWS_STAGING',
	LOCAL: 'LOCAL',
};

export const API_ENV = __CODING_BAR_API_ENV__;

const _apiUrl = {
	[ENV.PROD_AWS]: {
		MEOWBIT: 'https://meowbit-codinabr-ai.firebaseapp.com/',
		MICROBIT: 'https://api.codingbar.ai/microbit/index.html',
		PAY: 'https://api.codingbar.ai/service',
		DATABASE: 'https://api.codingbar.ai:8001',
		HOST: 'https://app.codingbar.ai',
	},
	[ENV.STAGING_AWS]: {
		MEOWBIT: 'https://meowbit-codinabr-ai.firebaseapp.com/',
		MICROBIT: 'https://api.codingbar.ai/microbit/index.html',
		PAY: 'https://api.codingbar.ai/service',
		DATABASE: 'https://api.codingbar.ai:8001',
		HOST: 'https://app.codingbar.ai',
	},
	DEFAULT: {
		MEOWBIT: 'https://meowbit-codinabr-ai.firebaseapp.com/',
		MICROBIT: 'https://api.codingbar.ai/microbit/index.html',
		PAY: 'https://api.codingbar.ai/service',
		DATABASE: 'https://api.codingbar.ai:8001',
		HOST: 'https://app.codingbar.ai',
	},
};
export const API_URL = _apiUrl[API_ENV] ? _apiUrl[API_ENV] : _apiUrl.DEFAULT;

export const LINE_QRCODE_URL = 'https://line.me/R/ti/p/%40ply0218v';
export const STUDENT_IMPORT_TEMPLATE_URL =
	'https://file.codingbar.ai/file/file?name=42ef32b4-acd6-4a6e-8b30-00f0acd3c400.csv&uid=f4f4fbaf-e4fe-4efe-94fc-06c15f457e89-aia-com';

export const STUFF_MAIL_LIST = ['tengjie.huang@airabbi.com', 'jerry@airabbi.com'];

export function getVersion() {
	return 'v1.0.10 20260817';
}

export function getDesktopVersions() {
	return [
		{
			version: '2.2',
			links: [
				{
					os: 'windows',
					osVersion: '64bit',
					feature: 'Generic',
					url: 'https://drive.google.com/file/d/1wSEItb5zjnTp3NFh74xiCAmwMDuZ5O3I', //change/reBuild 20220822
				},
				{
					os: 'mac',
					osVersion: '11',
					feature: 'Generic',
					url: 'https://drive.google.com/file/d/13OF0S2lxaDHNb72kcsUwGiBMnXRAcsEp/view',
				},
				{
					os: 'mac',
					osVersion: '10.13',
					feature: 'Generic',
					url: 'https://drive.google.com/file/d/1xzAXKEeL6UxQ0y4iwBgaYTw3xodsUtNT',
				},
			],
		},
		{
			version: '2.1',
			links: [
				{
					os: 'windows',
					feature: 'Generic',
					url: 'https://drive.google.com/file/d/1-y1mxO4kSTTw-xqdLTATUXsxEVkKfN3g',
				},
				{
					os: 'windows',
					feature: 'DataScience',
					url: 'https://drive.google.com/file/d/1-y1mxO4kSTTw-xqdLTATUXsxEVkKfN3g',
				},
				{
					os: 'mac',
					feature: 'Generic',
					url: 'https://drive.google.com/file/d/1xzAXKEeL6UxQ0y4iwBgaYTw3xodsUtNT',
				},
				{
					os: 'mac',
					feature: 'DataScience',
					url: 'https://drive.google.com/file/d/1xzAXKEeL6UxQ0y4iwBgaYTw3xodsUtNT',
				},
			],
		},
	];
}

export function getCurrentDesktopVersion() {
	return '2.1';
}

export function getSpeedTimeThreshold() {
	return 1000;
}
